import { formatNumber } from '@legalosApi/helpers/formatNumber';
import AllowedValueTypes from '@legalosApi/types/AllowedValueTypes';
import { parseSimpleDate } from '@legalosApi/helpers/parseSimpleDate';
import QuestionType from '@legalosApi/types/QuestionType';
import { translations } from '@locales/translations';
// date-fns v4: use root imports ("/esm" deprecated / removed)
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { TFunction } from 'react-i18next';

export function localizeValue({
  value,
  type,
  locale,
  t,
}: {
  value: AllowedValueTypes | AllowedValueTypes[];
  type: QuestionType;
  locale: string;
  t: TFunction<'translation', undefined>;
}): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  switch (type) {
    case QuestionType.DATE:
      // Accepts the LegalOS object as well as its JSON-string form (user values);
      // a malformed value renders empty instead of throwing "Invalid time value".
      const simpleDate = parseSimpleDate(value);
      if (simpleDate) {
        const dateValue = new Date(simpleDate.year, simpleDate.month, simpleDate.day);
        return format(dateValue, 'P', {
          locale: (locale || 'de_DE').toLowerCase().startsWith('de') ? de : enUS,
        });
      }
      return '';
    case QuestionType.CURRENCY:
      return formatNumber(Number(value), locale, true);
    case QuestionType.FLOAT:
      return formatNumber(value as number, locale, false);
    case QuestionType.BOOLEAN:
      // @ts-expect-error
      return t(value ? translations.inputs.yes : translations.inputs.no);
    default:
      return String(value);
  }
}
